import { render, staticRenderFns } from "./StatsBanner.vue?vue&type=template&id=6ae795eb&scoped=true"
import script from "./StatsBanner.vue?vue&type=script&lang=js"
export * from "./StatsBanner.vue?vue&type=script&lang=js"
import style0 from "./StatsBanner.vue?vue&type=style&index=0&id=6ae795eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae795eb",
  null
  
)

export default component.exports